import React from "react";
import "./css/font-awesome.min.css";
import "./css/style.css";
import backgroundGif2 from "./img/gifWhite.gif";
import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import logo from "./img/Medco_full_Logo.png";

function PrivacyPolicy() {
  const navigate = useNavigate();
  const effectiveDate = "June 11, 2025";

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="background-container">
          <img src={backgroundGif2} alt="Medical background" className="background-gif" />
        </div>

        <div className="corner-buttons">
          <button className="secondary-btn corner-btn left-btn" onClick={() => navigate("/")}>
            <ChevronLeft /> Home
          </button>
        </div>

        <div className="centered-content">
          <h1>Privacy Policy</h1>
          <p>Effective Date: {effectiveDate}</p>
        </div>
      </div>

      {/* Main Content */}
      <section className="value-props" style={{ padding: "0 30px" }}>
        <div className="container" style={{ alignItems: "initial" }}>
          <h2>1. Introduction</h2>
          <p>
            Welcome to Med-CO. We value your privacy and are committed to protecting your personal
            data. This policy explains how we collect, use, disclose, and safeguard your information
            when you visit our website or use our services.
          </p>

          <h2>2. Information We Collect</h2>
          <h3>2.1 Personal Data</h3>
          <p>
            Name, email address, phone number, and other identifiers you provide when registering or
            contacting us.
          </p>
          <h3>2.2 Usage Data</h3>
          <p>
            Information about how you interact with our platform (pages visited, features used,
            device and browser details, IP address).
          </p>
          <h3>2.3 Cookies & Tracking</h3>
          <p>
            We use cookies and similar tracking technologies to enhance your experience. You can
            manage preferences through your browser settings.
          </p>

          <h2>3. How We Use Your Information</h2>
          <ul>
            <li>To provide, maintain, and improve our services.</li>
            <li>To communicate updates, marketing messages, and important notices.</li>
            <li>To personalize content and recommendations.</li>
            <li>To detect, prevent, and address technical issues and fraud.</li>
          </ul>

          <h2>4. Data Sharing & Disclosure</h2>
          <p>
            We may share information with:
            <ul>
              <li>Service providers (e.g., hosting, payment, analytics)</li>
              <li>Business partners under strict confidentiality agreements</li>
              <li>Law enforcement or regulators when required by law</li>
            </ul>
          </p>

          <h2>5. Data Retention</h2>
          <p>
            We retain your data only for as long as necessary to fulfill the purposes outlined in
            this policy or as required by law.
          </p>

          <h2>6. Your Rights</h2>
          <p>
            Depending on your jurisdiction, you may have the right to access, correct, delete, or
            restrict processing of your personal data. To exercise these rights, please contact us.
          </p>

          <h2>7. Security</h2>
          <p>
            We implement industry-standard measures (encryption, access controls) to protect your
            data, but no method is 100% secure.
          </p>

          <h2>8. International Transfers</h2>
          <p>
            Your data may be processed in countries outside your own. We ensure appropriate
            safeguards are in place, such as standard contractual clauses.
          </p>

          <h2>9. Children's Privacy</h2>
          <p>
            Our services are not directed at children under 16. We do not knowingly collect personal
            data from minors.
          </p>

          <h2>10. Changes to This Policy</h2>
          <p>
            We may update this policy periodically. We will notify you of significant changes by
            posting the new effective date here.
          </p>

          <h2>11. Contact Us</h2>
          <p>
            If you have any questions or requests, please email us at{" "}
            <a
              href="mailto:ceo@thedevhouse.io"
              style={{ color: "inherit", textDecoration: "underline" }}
            >
              ceo@thedevhouse.io
            </a>
            .
          </p>
        </div>
      </section>

      {/* Footer (same as Home) */}
      <footer className="main-footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-about">
              <img src={logo} alt="Med-CO" className="footer-logo" />
              <p>The complete clinic management platform,</p>
              <p>for modern healthcare providers.</p>
            </div>
            <div className="footer-contact">
              <h4>Contact Us</h4>
              <p>
                <i className="fa fa-envelope"></i>
                <a
                  href="mailto:ceo@thedevhouse.io"
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  ceo@thedevhouse.io
                </a>
              </p>
              <p>
                <i className="fa fa-phone"></i>
                <a href="tel:+2010016128869" style={{ color: "inherit", textDecoration: "none" }}>
                  +20 100 16128869
                </a>
              </p>
              <p>
                <i class="fa fa-lock" />
                <Link to="/privacy-policy" style={{ color: "inherit", textDecoration: "none" }}>
                  Privacy Policy
                </Link>
              </p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Med-CO. All rights reserved.</p>
            <div className="legal-links">
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/terms-of-service">Terms of Service</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;
